import React, { Component } from "react";
import _ from "lodash";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Field, reduxForm, getFormValues, getFormSyncErrors } from "redux-form";
import { Form, Input, message, Upload, Modal, Tabs, Icon } from "antd";
import { EditorState, convertFromRaw, convertToRaw } from "draft-js";
import {
  fetchFirstSection,
  updateFirstSection,
} from "../../actions/FirstSection";
import * as firebase from "firebase";
import { Editor } from "react-draft-wysiwyg";

const FormItem = Form.Item;
const { TextArea } = Input;
const TabPane = Tabs.TabPane;

class CreatePromotion extends Component {
  constructor(props) {
    super(props);

    let currentContent = null;
    let editorState = null;
    editorState = processInitialContent(currentContent);

    this.state = {
      activeTabKey: "en",
      fileList: [],
      editorState: editorState,
    };
  }

  componentDidMount() {
    this.props.fetchFirstSection((about) => {
      this.setState({
        ...this.state,
        editorState: processInitialContent(about[Object.keys(about)[0]]),
      });
    });
  }

  // Render
  renderField(field) {
    const {
      meta: { touched, error },
      input,
      placeholder,
      label,
      htmlFor,
      type,
      required,
    } = field;
    const className = `form-group input-txt ${
      touched && error ? "input-error" : ""
    }`;

    return (
      <div className={className}>
        <label htmlFor={htmlFor}>{label}</label>
        <input
          className="form-control"
          type={type}
          id={htmlFor}
          placeholder={placeholder}
          required={required}
          {...input}
        />
        <span className="error-message">{touched ? error : ""}</span>
      </div>
    );
  }

  renderImageView(cover) {
    const { previewVisible, fileList } = this.state;
    const { initialValues } = this.props;
    const uploadButton = (
      <div className="form-group add-more-btn button-upload">
        <img src="/resources/img/ic-add.png" alt="" />
        <label>Upload Image</label>
      </div>
    );

    let uploadedImage = null;
    if (initialValues) {
      uploadedImage = initialValues.image_paths;
    }

    let file = null;
    let src = cover;
    if (fileList.length > 0) {
      file = fileList[0];
      if (file.url) {
        src = file.url;
      }
    }

    return (
      <div
        className="news-icon"
        style={{
          paddingLeft: 26,
          paddingRight: 26,
        }}
      >
        {uploadedImage && !file && (
          <img
            src={uploadedImage}
            alt=""
            style={{
              width: "100%",
              paddingBottom: 12,
            }}
          />
        )}
        <Upload
          name="cover"
          listType="picture-card"
          className="product-image-uploader"
          // action="//jsonplaceholder.typicode.com/posts/"
          onChange={this.handleCoverChange.bind(this)}
          onPreview={this.handlePreview.bind(this)}
          fileList={fileList}
          onRemove={this.handleCoverDelete.bind(this)}
          accept="image/*"
          customRequest={this.customRequest.bind(this)}
        >
          {file ? null : uploadButton}
        </Upload>
        <Modal
          visible={previewVisible}
          footer={null}
          closable={false}
          onCancel={this.onCoverModalClose.bind(this)}
          width={800}
        >
          <img src={src ? src : ""} alt="" style={{ width: "100%" }} />
        </Modal>
      </div>
    );
  }

  renderEditor(editorState, { lang, title }) {
    return (
      <div>
        {/* <div className="form-group txt-area">
                    <label htmlFor="content-en">{`${title}:`}</label>
                </div> */}
        <Editor
          // initialEditorState={editorState[lang]}
          editorState={editorState[lang]}
          toolbarClassName="rdw-storybook-toolbar"
          // wrapperClassName="form-group txt-area"
          editorClassName="form-control"
          onEditorStateChange={(editorState) => {
            this.onEditorStateChange(editorState, lang);
          }}
          toolbar={{
            options: [
              "inline",
              "blockType",
              "list",
              "textAlign",
              "link",
              "embedded",
              "image",
              "history",
            ],
            inline: {
              inDropdown: false,
              options: [
                "bold",
                "italic",
                "underline",
                "strikethrough",
                "monospace",
              ],
            },
            // image: {
            //   uploadEnabled: true,
            //   uploadCallback: uploadImageCallBack,
            //   alt: { present: false, mandatory: false },
            //   previewImage: true,
            //   alignmentEnabled: true,
            //   inputAccept: "image/gif,image/jpeg,image/jpg,image/png,image/svg",
            //   defaultSize: {
            //     height: "auto",
            //     width: "auto",
            //   },
            // },
          }}
        />
      </div>
    );
  }

  render() {
    const { promotion, activeTabKey, editorState } = this.state;
    const { match, history, location, handleSubmit } = this.props;
    const isNew = match.path === "/promotions/new";

    return (
      <div>
        <div className="container-fluid">
          <form onSubmit={handleSubmit(this.submitForm.bind(this))}>
            <div className="form-header">
              <div className="row">
                <div className="col close-page-btn">
                  <Link to={`/promotions`} className="cross-hover">
                    <img src="/resources/img/ic-x.png" alt="close button" />
                  </Link>
                </div>
                <div className="col-8">
                  <h3>{`${isNew ? "New" : "Edit"} Content`}</h3>
                </div>
                <div className="col">
                  <button className="btn button green-btn" type="submit">
                    {isNew ? "Add Content" : "Save"}
                  </button>
                </div>
              </div>
            </div>
            <div className="form-body">
              <div className="form-content edit-promotion">
                <div className="promotion">
                  <h5>Content</h5>
                  <Field
                    name="titleEn"
                    label="Title (English):"
                    placeholder="Title (English)"
                    htmlFor="title-en"
                    component={this.renderField}
                    type="text"
                  />
                  <Field
                    name="titleTh"
                    label="Title (ไทย):"
                    placeholder="Title (ไทย)"
                    htmlFor="title-th"
                    component={this.renderField}
                    type="text"
                  />
                  <Field
                    name="titleZh"
                    label="Title (Chinese):"
                    placeholder="Title (Chinese)"
                    htmlFor="title-zh"
                    component={this.renderField}
                    type="text"
                  />
                </div>
                <div className="divider" />

                <div className="cover-content">
                  <h5>{"Image"}</h5>
                  {this.renderImageView()}
                </div>
                <div className="divider" />

                <div className="cover-content">
                  <h5>Description</h5>
                  <div className="form-group txt-area">
                    <Tabs
                      activeKey={activeTabKey}
                      onChange={this.onTabChange.bind(this)}
                      animated={false}
                    >
                      <TabPane tab="English" key="en">
                        {this.renderEditor(editorState, {
                          lang: "en",
                          title: "Content (English)",
                        })}
                      </TabPane>
                      <TabPane tab="Thai" key="th">
                        {this.renderEditor(editorState, {
                          lang: "th",
                          title: "Content (Thai)",
                        })}
                      </TabPane>
                      <TabPane tab="Chinese" key="zh">
                        {this.renderEditor(editorState, {
                          lang: "zh",
                          title: "Content (Chinese)",
                        })}
                      </TabPane>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }

  // Operation
  submitForm(values) {
    const {
      fileList,
      editorState: { en, th, zh },
    } = this.state;
    const { initialValues } = this.props;
    console.log(values, "data");
    console.log("state :>> ", this.state);
    const imageFile =
      fileList.length > 0
        ? fileList[0].originalFile
        : initialValues.image_paths;
    const newDataSet = {
      [values.id]: {
        image_paths: imageFile,
        title: {
          en: values.titleEn,
          th: values.titleTh,
          zh: values.titleZh,
        },
      },
    };
    let contents = {};
    if (en) {
      contents.en = JSON.stringify(convertToRaw(en.getCurrentContent()));
    }
    if (th) {
      contents.th = JSON.stringify(convertToRaw(th.getCurrentContent()));
    }
    if (zh) {
      contents.zh = JSON.stringify(convertToRaw(zh.getCurrentContent()));
    }
    newDataSet[values.id].content = contents;

    const hideLoading = message.loading("Saving Content", 0);
    this.props.updateFirstSection(newDataSet, (error) => {
      hideLoading();
      if (error) {
        message.error("Error saving content!");
      } else {
        message.success("First section Content has been updated!");
      }
    });
  }
  onTabChange(key) {
    this.setState({ activeTabKey: key });
  }
  onCoverModalClose() {
    this.setState({ previewVisible: false });
  }
  handleCoverChange({ fileList }) {
    console.log("fileList", fileList);
    this.setState({ fileList: fileList });
  }
  handlePreview(file) {
    this.setState({ previewVisible: true });
  }
  handleCoverDelete(file) {
    console.log(file);
  }
  customRequest(event) {
    const file = event.file;
    const reader = new FileReader();
    reader.onloadend = (fr, ev) => {
      const originalFile = this.state.fileList[0];
      this.setState({
        fileList: [{ ...file, url: reader.result, originalFile: originalFile }],
      });
    };

    reader.readAsDataURL(file);
  }
  onEditorStateChange(editorState, lang) {
    let updateState = { ...this.state.editorState };
    updateState[lang] = editorState;

    this.setState({ editorState: updateState });
  }
}

const validate = (values) => {
  console.log(values);

  const errors = {};

  if (!values.promotionEn) {
    errors.promotionEn = "Promotion name in English is required.";
  }
  if (!values.promotionTh) {
    errors.promotionTh = "Promotion name in Thai (ไทย) is required.";
  }
  if (!values.discount) {
    errors.discount = "Discount value is required.";
  }

  return errors;
};

function processInitialContent(content) {
  let editorStateEn = null;
  if (content && content.content && content.content.en) {
    const contentStateEn = convertFromRaw(JSON.parse(content.content.en));
    editorStateEn = EditorState.createWithContent(contentStateEn);
  } else {
    editorStateEn = EditorState.createEmpty();
  }

  let editorStateTh = null;
  if (content && content.content && content.content.th) {
    const contentStateTh = convertFromRaw(JSON.parse(content.content.th));
    editorStateTh = EditorState.createWithContent(contentStateTh);
  } else {
    editorStateTh = EditorState.createEmpty();
  }

  let editorStateZh = null;
  if (content && content.content && content.content.zh) {
    const contentStateZh = convertFromRaw(JSON.parse(content.content.zh));
    editorStateZh = EditorState.createWithContent(contentStateZh);
  } else {
    editorStateZh = EditorState.createEmpty();
  }

  const editorState = {
    en: editorStateEn,
    th: editorStateTh,
    zh: editorStateZh,
  };

  return editorState;
}

function mapStateToProps(state, ownProps) {
  const { firstSection } = state.firstSection;

  let sectionId = "";
  let defaultVal = {};
  if (firstSection && Object.keys(firstSection)[0]) {
    sectionId = Object.keys(firstSection)[0];
    let defaultData = firstSection[sectionId];
    defaultData.titleTh = defaultData.title.th;
    defaultData.titleEn = defaultData.title.en;
    defaultData.titleZh = defaultData.title.zh;
    defaultVal = {
      ...defaultData,
    };
  } else {
    defaultVal = {};
  }
  return {
    sectionId,
    firstSection,
    initialValues: defaultVal,
    fields: getFormValues("SectionForm")(state),
    fieldErrors: getFormSyncErrors("SectionForm")(state),
  };
}

CreatePromotion = reduxForm({
  validate,
  form: "SectionForm",
  enableReinitialize: true,
})(CreatePromotion);

CreatePromotion = connect(
  mapStateToProps,
  {
    fetchFirstSection,
    updateFirstSection,
  }
)(CreatePromotion);

export default CreatePromotion;



// WEBPACK FOOTER //
// ./src/views/first-section-content/index.js